/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components), {Tag, Social} = _components;
  if (!Social) _missingMdxReference("Social", true);
  if (!Tag) _missingMdxReference("Tag", true);
  return React.createElement(React.Fragment, null, React.createElement(Tag, {
    id: "gagedavis"
  }), "\n", React.createElement(_components.p, null, "SUBSCRIBE FOR MORE VIDEOS!"), "\n", React.createElement(_components.p, null, "HannahVonStevens.com"), "\n", React.createElement(_components.p, null, "BOOK ME: ", React.createElement(_components.a, {
    href: "mailto:HannahVonStevens@gmail.com"
  }, "HannahVonStevens@gmail.com")), "\n", React.createElement(_components.p, null, "FOLLOW ME:"), "\n", React.createElement(Social, {
    to: "instagram",
    id: "HannahVonStevens"
  }), "\n", React.createElement(Social, {
    to: "facebook",
    id: "HannahVonStevens"
  }), "\n", React.createElement(Social, {
    to: "twitter",
    id: "HannahVonSteven"
  }), "\n", React.createElement(Social, {
    to: "snapchat",
    id: "HannahVonSteven"
  }));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
